// extracted by mini-css-extract-plugin
export default {"coverPictureSizing":"StoreCover-module--coverPictureSizing--UgZ9U"};